import type { SanityPageBuilderSection, SanityPageBuilderTextMediaCItem, SanityPageBuilderTextMediaCSection } from "@ouster/shared";
import { TextMediaCBlockView, TextMediaCItemRowView } from "~/features/blocks/inventory/text-media-c";
import { SanityRichText } from "~/features/sanity/rich-text";
import { hasRenderableSanityMedia, SanityMediaFigure } from "./media-figure";
type Props = {
  section: SanityPageBuilderSection & {
    loaded?: boolean;
    sectionContent: SanityPageBuilderTextMediaCSection;
  };
};
export function SanityTextMediaCSection({
  section
}: Props) {
  const {
    sectionContent,
    sectionSettings
  } = section;
  const text = sectionContent.text?.length ? <SanityRichText value={sectionContent.text} /> : undefined;
  const hasMedia = hasRenderableSanityMedia(sectionContent.media);
  const items = sectionContent.items ?? [];
  return <TextMediaCBlockView<SanityPageBuilderTextMediaCItem> anchor={{
    id: sectionSettings?.sectionId?.current || sectionSettings?.anchorName || section._key,
    name: sectionSettings?.anchorName
  }} getItemKey={(item, index) => item._key || index} hasTopDivider={sectionSettings?.hasTopDivider ?? true} headline={sectionContent.headline} items={items} mediaDesktop={hasMedia ? <SanityMediaFigure fit="cover" media={sectionContent.media} sizes="lg:50vw" /> : undefined} mediaMobile={hasMedia ? <SanityMediaFigure media={sectionContent.media} ratio="3/2" sizes="lg:50vw" /> : undefined} mediaPosition={sectionContent.mediaPosition} mode={sectionSettings?.mode || "light"} renderItem={item => {
    const description = item.description?.length ? <SanityRichText value={item.description} /> : undefined;
    return <TextMediaCItemRowView description={description} media={hasRenderableSanityMedia(item.media) ? <SanityMediaFigure media={item.media} ratio="1/1" sizes="64px" /> : undefined} title={item.title} />;
  }} sectionProps={{
    "data-sanity-section-key": section._key,
    "data-sanity-section-type": section._type
  }} text={text} theme={sectionSettings?.theme || "white"} />;
}